// Generated by ai/scripts/export_nuru_rules.py. Edit the Python JSON sources, then regenerate.
export const NURU_TAXONOMY = {
  "version": "nuru-routing-v2",
  "review_status": "unreviewed_demo",
  "score_meaning": "keyword evidence count, not probability or diagnosis",
  "topics": [
    {
      "slug": "irregular-periods",
      "keywords": [
        "irregular period",
        "late period",
        "missed period",
        "cycle",
        "period is late",
        "periods are irregular",
        "skipped period",
        "hedhi isiyo ya kawaida",
        "hedhi imechelewa",
        "hedhi zisizo za kawaida"
      ],
      "broad_topic": "menstrual_health"
    },
    {
      "slug": "severe-period-pain",
      "keywords": [
        "period pain",
        "cramps",
        "painful period",
        "dysmenorrhea",
        "pain during my period",
        "period cramps",
        "maumivu makali wakati wa hedhi",
        "maumivu ya hedhi"
      ],
      "broad_topic": "menstrual_health"
    },
    {
      "slug": "heavy-bleeding",
      "keywords": [
        "heavy bleeding",
        "heavy period",
        "flooding",
        "soaking",
        "clots",
        "bleeding a lot",
        "prolonged bleeding",
        "bleeding for weeks",
        "damu nyingi",
        "kutokwa na damu nyingi",
        "hedhi nzito"
      ],
      "broad_topic": "menstrual_health"
    },
    {
      "slug": "pcos",
      "keywords": [
        "pcos",
        "polycystic ovary syndrome"
      ],
      "broad_topic": "menstrual_health"
    },
    {
      "slug": "endometriosis",
      "keywords": [
        "endometriosis",
        "endo"
      ],
      "broad_topic": "menstrual_health"
    },
    {
      "slug": "fibroids",
      "keywords": [
        "fibroid",
        "fibroids",
        "uvimbe kwenye mfuko wa uzazi"
      ],
      "broad_topic": "menstrual_health"
    },
    {
      "slug": "painful-sex",
      "keywords": [
        "pain during sex",
        "painful sex",
        "pain during intercourse",
        "dyspareunia",
        "sex is painful",
        "maumivu wakati wa ngono"
      ],
      "broad_topic": "sexual_health"
    },
    {
      "slug": "contraception",
      "keywords": [
        "contraception",
        "contraceptive",
        "family planning",
        "birth control",
        "iud",
        "depo",
        "uzazi wa mpango"
      ],
      "broad_topic": "sexual_health"
    },
    {
      "slug": "stis",
      "keywords": [
        "sti",
        "stis",
        "std",
        "stds",
        "sexually transmitted infection",
        "maambukizi ya zinaa"
      ],
      "broad_topic": "sexual_health"
    },
    {
      "slug": "fertility",
      "keywords": [
        "conceive",
        "ovulation",
        "trying for a baby",
        "infertility",
        "can't get pregnant",
        "cant get pregnant",
        "ugumba",
        "kutafuta mtoto"
      ],
      "broad_topic": null
    },
    {
      "slug": "pregnancy-warning-signs",
      "keywords": [
        "pregnancy warning signs",
        "bleeding while pregnant",
        "pregnant and bleeding",
        "baby stopped moving",
        "reduced fetal movement",
        "damu wakati wa ujauzito"
      ],
      "broad_topic": null
    },
    {
      "slug": "postpartum-anxiety",
      "keywords": [
        "postpartum depression",
        "postpartum anxiety",
        "postnatal depression",
        "baby blues",
        "huzuni baada ya kujifungua",
        "wasiwasi baada ya kujifungua"
      ],
      "broad_topic": "postpartum"
    },
    {
      "slug": "cervical-screening",
      "keywords": [
        "cervical screening",
        "pap smear",
        "hpv",
        "smear test",
        "uchunguzi wa saratani ya mlango wa kizazi"
      ],
      "broad_topic": null
    },
    {
      "slug": "breast-health",
      "keywords": [
        "breast",
        "breasts",
        "nipple",
        "matiti"
      ],
      "broad_topic": null
    },
    {
      "slug": "perimenopause",
      "keywords": [
        "perimenopause",
        "kipindi cha kuelekea ukomo wa hedhi"
      ],
      "broad_topic": "healthy_aging"
    },
    {
      "slug": "menopause",
      "keywords": [
        "menopause",
        "ukomo wa hedhi"
      ],
      "broad_topic": "healthy_aging"
    },
    {
      "slug": "pms-pmdd",
      "keywords": [
        "pms",
        "pmdd",
        "mood before my period",
        "angry before my period",
        "crying before my period",
        "mabadiliko ya hisia kabla ya hedhi"
      ],
      "broad_topic": "menstrual_health"
    },
    {
      "slug": "pelvic-floor",
      "keywords": [
        "leaking urine",
        "pelvic floor",
        "prolapse",
        "kuvuja mkojo"
      ],
      "broad_topic": null
    }
  ]
} as const;
export const NURU_SAFETY = {
  "version": "draft-v2-nuru",
  "review_status": "unreviewed_demo",
  "rules": [
    {
      "id": "heavy_bleeding",
      "patterns": [
        "\\bbleeding (?:very )?heavily\\b",
        "\\bheavy bleeding\\b",
        "\\bdamu nyingi\\b"
      ]
    },
    {
      "id": "fainting",
      "patterns": [
        "\\b(?:fainted|fainting|feel faint|feeling faint|unconscious)\\b",
        "\\b(?:kuzimia|nimezimia|ninazimia|nazimia|napoteza fahamu)\\b"
      ]
    },
    {
      "id": "severe_pain",
      "patterns": [
        "\\bsevere (?:abdominal |pelvic |chest |period |menstrual )?pain\\b",
        "\\bmaumivu makali\\b"
      ]
    },
    {
      "id": "breathing",
      "patterns": [
        "\\b(?:cannot|can.t|unable to) breathe\\b",
        "\\b(?:difficulty breathing|shortness of breath)\\b",
        "\\b(?:siwezi kupumua|shida ya kupumua)\\b"
      ]
    },
    {
      "id": "self_harm",
      "patterns": [
        "\\b(?:kill myself|end my life|hurt myself|suicid\\w*)\\b",
        "\\b(?:kujiua|kujidhuru)\\b"
      ]
    },
    {
      "id": "immediate_threat",
      "patterns": [
        "\\b(?:in immediate danger|being attacked|threatening to kill)\\b",
        "\\b(?:niko hatarini|ananishambulia)\\b"
      ]
    },
    {
      "id": "violence_assault",
      "patterns": [
        "\\b(?:rape|raped|sexual assault|forced me|forced himself|beat me|beats me)\\b",
        "\\b(?:ubakaji|nimebakwa|amenibaka|ananipiga)\\b"
      ]
    },
    {
      "id": "pregnancy_concern",
      "patterns": [
        "\\b(?:pregnant|pregnancy|mjamzito|ujauzito|mimba)\\b"
      ],
      "all_patterns": [
        "\\b(?:bleeding|bleed|damu|severe headache|blurred vision|reduced movement|baby stopped moving|maumivu makali)\\b"
      ]
    },
    {
      "id": "postpartum_concern",
      "patterns": [
        "\\b(?:postpartum|after birth|after giving birth|since delivery|baada ya kujifungua)\\b"
      ],
      "all_patterns": [
        "\\b(?:bleeding|bleed|fever|chest pain|difficulty breathing|damu|homa|kupumua)\\b"
      ]
    }
  ]
} as const;
export const DEMO_TAXONOMY = {
  "version": "nuru-demo-topics-v2",
  "review_status": "unreviewed_demo",
  "topics": [
    {
      "id": "menstrual_health",
      "label_en": "Menstrual health",
      "label_sw_draft": "Afya ya hedhi",
      "library_area": "menstrual-health",
      "keywords": [
        "menstrual",
        "menstruation",
        "period",
        "periods",
        "period pain",
        "cramps",
        "hedhi",
        "pcos",
        "endometriosis",
        "fibroids",
        "pms",
        "pmdd"
      ],
      "ignore_phrases": [
        "ukomo wa hedhi"
      ]
    },
    {
      "id": "healthy_aging",
      "label_en": "Healthy aging",
      "label_sw_draft": "Afya wakati wa kuzeeka",
      "library_area": "healthy-ageing",
      "keywords": [
        "healthy aging",
        "healthy ageing",
        "aging",
        "ageing",
        "menopause",
        "perimenopause",
        "older women",
        "ukomo wa hedhi",
        "kuzeeka",
        "wanawake wazee"
      ],
      "ignore_phrases": []
    },
    {
      "id": "postpartum",
      "label_en": "Postpartum",
      "label_sw_draft": "Afya baada ya kujifungua",
      "library_area": "postpartum",
      "keywords": [
        "postpartum",
        "postnatal",
        "after birth",
        "after childbirth",
        "after delivery",
        "breastfeeding",
        "baada ya kujifungua",
        "kunyonyesha"
      ],
      "ignore_phrases": []
    },
    {
      "id": "sexual_health",
      "label_en": "Sexual health",
      "label_sw_draft": "Afya ya kingono",
      "library_area": "sexual-health",
      "keywords": [
        "sexual health",
        "sex",
        "contraception",
        "contraceptive",
        "sti",
        "stis",
        "sexually transmitted",
        "consent",
        "abortion",
        "termination of pregnancy",
        "kingono",
        "ngono",
        "uzazi wa mpango",
        "utoaji mimba",
        "kutoa mimba",
        "maambukizi ya zinaa"
      ],
      "ignore_phrases": []
    },
    {
      "id": "mental_health",
      "label_en": "Mental health",
      "label_sw_draft": "Afya ya akili",
      "library_area": "mental-health",
      "keywords": [
        "mental health",
        "depression",
        "depressed",
        "anxiety",
        "anxious",
        "emotional support",
        "counselling",
        "counseling",
        "stress",
        "stressed",
        "sad",
        "sadness",
        "afya ya akili",
        "huzuni",
        "wasiwasi",
        "msongo",
        "msaada wa kihisia"
      ],
      "ignore_phrases": []
    }
  ],
  "unknown_output": "uncertain",
  "scope": "Educational routing only; category mention is not diagnosis or a personal disclosure.",
  "subtopics": [
    {
      "id": "abortion",
      "parent_topic": "sexual_health",
      "related_topic": "mental_health",
      "related_topic_condition": "Only when mental-health or emotional-support wording is also explicitly present. No automatic mental-illness label.",
      "keywords": [
        "abortion",
        "termination of pregnancy",
        "utoaji mimba",
        "kutoa mimba"
      ]
    }
  ],
  "ambiguous_pregnancy_loss_terms": [
    "mimba kutoka",
    "kuharibika kwa mimba",
    "mimba kuharibika"
  ],
  "out_of_scope_keywords": [
    "fertility",
    "infertility",
    "trying to conceive",
    "pregnancy",
    "pregnant",
    "ujauzito",
    "mjamzito",
    "cancer",
    "saratani"
  ],
  "translation_status": "Kiswahili labels are drafts requiring a Kenyan Swahili reviewer."
} as const;
